import { Controller } from "@hotwired/stimulus"

// Keeps removal controls out of the compact Drilling rows until the student
// explicitly enters edit mode. Playback links leave the tab order while editing
// so the two modes never expose competing actions.
export default class extends Controller {
  static targets = ["toggle", "link"]

  connect() {
    this.setEditing(false)
  }

  toggle() {
    this.setEditing(!this.element.classList.contains("is-editing"))
  }

  setEditing(editing) {
    this.element.classList.toggle("is-editing", editing)
    this.toggleTarget.textContent = editing ? "Done" : "Edit"
    this.toggleTarget.setAttribute("aria-pressed", editing.toString())

    this.linkTargets.forEach((link) => {
      if (editing) {
        link.setAttribute("aria-disabled", "true")
        link.setAttribute("tabindex", "-1")
      } else {
        link.removeAttribute("aria-disabled")
        link.removeAttribute("tabindex")
      }
    })
  }
}
